/** Map canonical material family → calculated-task section parent_type. */
export const PARENT_TYPE = {
  PRODUCT: 1,
  FITTING: 2,
  FIXING: 3
}

export function familyToParentType (family) {
  switch (String(family || '').toLowerCase()) {
    case 'fitting':
      return PARENT_TYPE.FITTING
    case 'fixing':
      return PARENT_TYPE.FIXING
    case 'product':
    case 'pipe':
    case 'other':
    default:
      return PARENT_TYPE.PRODUCT
  }
}

/**
 * Normalize materials for calculated Includes sections.
 * Prefers backend `family` / `parent_type`; falls back to legacy heuristics.
 */
export function normalizeForCalculatedIncludes (items) {
  return (items || []).map(item => {
    if (item && item.family) {
      return Object.assign({}, item, { parent_type: familyToParentType(item.family) })
    }

    const existing = Number(item && item.parent_type)
    if ([1, 2, 3].includes(existing)) {
      return Object.assign({}, item, { parent_type: existing })
    }

    // Legacy fallback for unsynced task JSON without family
    const hint = (
      ((item && item.category) || '') + ' ' +
      ((item && item.type_name_full) || '') + ' ' +
      ((item && item.type) || '') + ' ' +
      ((item && item.description) || '')
    ).toLowerCase()

    let parentType = PARENT_TYPE.PRODUCT
    if (
      hint.indexOf('fixing') !== -1 ||
      hint.indexOf('fastener') !== -1 ||
      hint.indexOf('clip') !== -1 ||
      hint.indexOf('bracket') !== -1 ||
      hint.indexOf('saddle') !== -1 ||
      hint.indexOf('anchor') !== -1 ||
      hint.indexOf('strap') !== -1 ||
      hint.indexOf('screw') !== -1 ||
      hint.indexOf('bolt') !== -1
    ) {
      parentType = PARENT_TYPE.FIXING
    } else if (hint.indexOf('fitting') !== -1 || hint.indexOf('capillary') !== -1) {
      parentType = PARENT_TYPE.FITTING
    }

    return Object.assign({}, item, { parent_type: parentType })
  })
}
